import { Box, Drawer, IconButton, } from '@mui/material'
import { Routes, Route, Outlet } from 'react-router-dom'
import AppMenu from 'components/AppMenu'
// import Employments from '../components/Widgets/Employments'
import Enrollments from '../components/Enrollments'
import Dashboard from './Dashboard'
import Staff from './Staff'
import Student from './Student'
import Settings from './Settings'
// import CourseSession from './Academic/CourseSession'
import GradingReport from './Academic/FinalGrades'
import ParentalStudent from './Academic/Student/ParentDetail'
import TeachersStudent from './Academic/Student'
import Approval from '../components/Approval'
import { useEffect, useState } from 'react'
import { Schedule } from './Academic/Schedule'
import { Attendance } from './Academic/Attendance'
import Member from './Member'
import Person from './Provider/Employees'
import NewPersonalForm from './Member/Person/Personal/Form/NewPersonalForm'
import Schools from './Schools'
import Report from './Report'
import Health from './Health'
import Calendar from './Calendar'
import Discipline from './Discipline'
import MyCoursesPage from './Academic/MyCourses'
import { getTypes, getServiceCampus } from '../store/lookup'
import { search as searchMentorships } from '../store/mentorship/mentorship'
import { search as searchCourseSessions } from '../store/academic/course-session'
import { useDispatch, useSelector } from 'react-redux'
import { useSession } from 'components/Providers'
import { hasPermission } from '../store'
import AssetManagement from './Asset'
import EsignList from './Academic/Esign'
import AdminEvaluation from './AdminEvaluation'
import SubstitutePortal from './Substitute'
import { RiMenuFoldLine, RiMenuUnfoldLine } from "react-icons/ri";
import Scheduling from './Scheduling'
import SchoolAttendance from './Attendance'
import LeaveRequest from './LeaveRequest'
import StudentDisciplinePage from './Academic/Discipline'
import StudentAdmissions from './Admissions'
import PeopleIndex from './Provider'
import Profile from './Profile'
import Role from './Role'
import ParentContacts from './Academic/Contacts'
import Mentorship from './Mentorship'
import PageNotFound from './PageNotFound'
import Protected from '../components/Protected'
import VisitorLog from './VisitorLog'
import Notification from './Notification'
import NeedsAttention from './NeedsAttention'

const drawerWidth = 240
const collapsedWidth = 64

export default function MainPage() {
  const dispatch = useDispatch()
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false)
  const { district, person } = useSession()
  const types = useSelector(state => state.lookup.types)
  const serviceCampus = useSelector(state => state.lookup.serviceCampus)
  const mentorships = useSelector(state => state.mentorship.mentorship.list)
  const courseSessionList = useSelector(state => state.academic.courseSession.list)

  useEffect(() => {
    if (!types) dispatch(getTypes())
  }, [types, dispatch])

  const isStaffFacing = Boolean(person?.type) && !['parent', 'student'].includes(person.type)

  useEffect(() => {
    if (isStaffFacing && !serviceCampus && district?.id) dispatch(getServiceCampus())
  }, [dispatch, isStaffFacing, Boolean(serviceCampus), district?.id])

  useEffect(() => {
    if (isStaffFacing && !mentorships && district?.id) dispatch(searchMentorships())
  }, [dispatch, isStaffFacing, Boolean(mentorships), district?.id])

  useEffect(() => {
    if (!courseSessionList && hasPermission('staff.staff')) dispatch(searchCourseSessions())
  }, [dispatch, person?.id])

  const menuCollapseToggle = () => {
    setIsMenuCollapsed(prevState => !prevState)
  }

  return (
    <>
      <Approval>
        <IconButton
          onClick={menuCollapseToggle}
          sx={{
            position: 'fixed',
            top: 15,
            left: isMenuCollapsed ? 75 : 225,
            zIndex: 1199,
            display: { xs: 'none', md: 'flex' },
            transform: isMenuCollapsed ? 'translateX(-50%)' : 'none',
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.main',
            },
            borderRadius: '10px',
            color: 'primary.contrastText',
            p: isMenuCollapsed ? 0.5 : 1,
          }}
        >
          {isMenuCollapsed ? <RiMenuUnfoldLine /> : <RiMenuFoldLine />}
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            backgroundColor: 'background.default',
            minHeight: '100vh',
          }}
        >
          <Box
            component="nav"
            id="app-nav"
            sx={{ displayPrint: 'none', width: { sm: isMenuCollapsed ? collapsedWidth : drawerWidth }, display: { xs: 'none', sm: 'none', md: 'block' }, flexShrink: { sm: 0 }, }}
          >

            <Drawer
              variant="permanent"
              sx={{
                width: isMenuCollapsed ? collapsedWidth : drawerWidth,

                flexShrink: 0,
                '& .MuiDrawer-paper': {
                  //height: '100%',
                  width: isMenuCollapsed ? collapsedWidth : drawerWidth,
                  boxSizing: 'border-box',
                  backgroundColor: 'primary.main',
                  borderRight: 'none',
                  transition: 'width 0.3s',
                },
              }}
              PaperProps={{
                sx: {
                  borderRadius: '8px',
                  //margin: '16px',
                  top: '15px',
                  height: 'calc(100vh - 30px)',
                  left: '15px',
                  overflow: 'auto',
                  zIndex: 1198,
                },
              }}
              open
            >
              <AppMenu
                isMenuCollapsed={isMenuCollapsed}
                menuCollapseToggle={menuCollapseToggle}
              />
            </Drawer>
          </Box>
          <Box component="main"
            sx={{
              my: 2,
              flexGrow: 1,
              pl: { sm: 4, xs: 1 },
              pr: { sm: 2, xs: 1 },
              width: {
                sm: isMenuCollapsed
                  ? `calc(100% - ${collapsedWidth}px)`
                  : `calc(100% - ${drawerWidth}px)`,
                xs: '100%'
              },
              //transform: isMenuCollapsed ? 'translateX(calc(100% - ${collapsedWidth}px))' : 'translateX(calc(100% - ${drawerWidth}px))',
              //transition: 'transform 0.3s ease, padding 0.3s ease'
            }}
          >
            <Routes>
              <Route path="/" element={<Outlet />}>
                <Route
                  index
                  element={
                    <Enrollments>
                      <Dashboard />
                    </Enrollments>
                  }
                />
                <Route path="schools/*" element={<Schools />} />
                <Route path="people/*" element={<PeopleIndex />} />
                <Route path="person/:personId/*" element={<Person />} />
                <Route path="member/:employmentType/new" element={<NewPersonalForm />} />
                <Route path="member/:employmentType/*" element={<Member />} />
                <Route path="member/:employmentType/:memberId/*" element={<Member />} />
                <Route path="staff/*" element={<Staff />} />
                <Route path="staff/:personId/*" element={<Staff />} />
                <Route path="student/*" element={<Student />} />
                <Route path="student/:personId/*" element={<Student />} />
                <Route path="academic/schedule" element={<Schedule />} />
                <Route path="academic/attendance" element={<Attendance />} />
                <Route path="academic/contacts" element={<ParentContacts />} />
                <Route path="academic/grading-report" element={<GradingReport />} />
                <Route path="academic/parent/student/*" element={<ParentalStudent />} />
                <Route path="academic/:employmentType/*" element={<TeachersStudent />} />
                <Route path="academic/:employmentType/:id/*" element={<TeachersStudent />} />
                <Route path="academic/my-courses/*" element={<MyCoursesPage />} />
                <Route path="academic/esign/*" element={<EsignList />} />
                <Route path="academic/discipline-stats/*" element={<StudentDisciplinePage />} />
                {/* <Route path="academic/course-session/:courseSessionId/*" element={<CourseSession />} /> */}
                <Route path="calendar" element={<Calendar />} />
                <Route path="settings/*" element={<Settings />} />
                <Route path="profile/*" element={<Profile />} />
                <Route path="permission" element={<Protected permission="setting.permission"><Role /></Protected>} />
                <Route path="permission/:id" element={<Protected permission="setting.permission"><Role /></Protected>} />
                <Route path="reports/*" element={<Protected permission="report.report"><Report /></Protected>} />
                <Route path="health/*" element={<Health />} />
                <Route path='asset-management/*' element={<AssetManagement />} />
                <Route path="discipline/*" element={<Discipline />} />
                <Route path='admin-evaluation/*' element={<AdminEvaluation />} />
                <Route path='substitute-portal/*' element={<SubstitutePortal />} />
                <Route path='scheduling/*' element={<Scheduling />} />
                <Route path='attendance/*' element={<SchoolAttendance />} />
                <Route path='leave-request/*' element={<LeaveRequest />} />
                <Route path='admission/*' element={<StudentAdmissions />} />
                <Route path='mentorship/*' element={<Mentorship />} />
                <Route path="visitor-log/*" element={<VisitorLog />} />
                <Route path="notification/*" element={<Notification />} />
                <Route path="needs-attention/*" element={<NeedsAttention />} />
                <Route path="*" element={<PageNotFound />} />
              </Route>
            </Routes>
          </Box>
        </Box>
      </Approval>
    </>
  )
}
